import React from 'react';
import PropTypes from 'prop-types';
import CorrLeftContentGrid from './CorrLeftContentGrid';
import CorrViewRightContent from './CorrViewRightContent';

function CorrView(props) {
  const { project, redrawChart } = props;
  return (
    <div data-test="corrView">
      <CorrLeftContentGrid
        project={project}
      />
      <CorrViewRightContent
        project={project}
        projectTitle={project.title}
        redrawChart={redrawChart}
      />
    </div>
  );
}

CorrView.propTypes = {
  redrawChart: PropTypes.bool,
  project: PropTypes.shape({
    title: PropTypes.string,
  }),
};

export default CorrView;
